<template>
  <DialogTemplate v-bind="props">
    <template #header>{{ title }}</template>
    <p>{{ label }}</p>
    <template #footer>
      <slot footer />
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
interface Props {
  title: string;
  label: string;
  iconHeader?: string | null;
  closeTimer?: number;
  closeClickOutside?: boolean;
  showControls?: boolean;
  position?: 'center' | 'top-right';
  align?: 'left' | 'center';
}
const props = defineProps({
  title: null,
  label: null,
  iconHeader: null,
  closeTimer: null,
  closeClickOutside: { type: Boolean, default: true },
  showControls: { type: Boolean, default: true },
  position: { default: 'center' },
  align: { default: 'left' }
});
</script>
<style lang="scss" scoped></style>
